import querystring from 'querystring';
import { ApiRequest } from '../Models';

class ApiService {
  async request<T>(request: ApiRequest): Promise<T> {
    // Get the url
    const url = this.getUrl(request);

    // Headers
    const headers = new Headers({
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
    });

    if (request.isMultipartFormData === true) {
      headers.delete('Content-Type');
    }

    if (process.env.NODE_ENV === 'development') {
      headers.append('origin', window.location.origin);
    }

    // construct a request
    const requestOptions: RequestInit = {
      method: request.method,
      headers,
      cache: 'default',
      body: this.getBody(request, request.files, request.secondaryFiles),
    };

    if (process.env.NODE_ENV === 'development') {
      if (request.cors === undefined || request.cors === true) {
        requestOptions.mode = 'cors';
      }
    }

    // await the response
    const response = await fetch(url, requestOptions);

    if (response.status >= 400) {
      throw new Error(`${response.status}: ${response.statusText}`);
    }

    const json = await response.json();

    const data = json as T;

    return data;
  }

  private getUrl(request: ApiRequest): string {
    let url = `/${request.slug}`;

    if (request.controller && request.controller.length > 0) {
      if (request.slug && request.slug.length > 0) {
        url = `/api/${request.controller}/${request.slug}`;
      } else {
        url = `/api/${request.controller}`;
      }
    }

    if (request.baseUrl) {
      url = `${request.baseUrl}${url}`;
    }

    if ((request.method === 'GET' || request.method === 'DELETE') && request.params) {
      url += '?';
      url += querystring.stringify({ ...request.params });
    }

    return url;
  }

  private getBody(
    request: ApiRequest,
    files?: File[] | FileList | null | [],
    secondaryFiles?: File[] | FileList | null | [],
  ): string | FormData | null {
    if (request.method === 'GET') {
      return null;
    }

    if (request.isMultipartFormData === true) {
      const formData = new FormData();

      formData.append('params', JSON.stringify(request.params));

      if (files && files.length > 0) {
        for (let index = 0; index < files.length; index++) {
          const file = files[index];
          formData.append(`files-${index}`, file);
        }
      }

      if (secondaryFiles && secondaryFiles.length > 0) {
        for (let index = 0; index < secondaryFiles.length; index++) {
          const file = secondaryFiles[index];
          formData.append(`secondaryfiles-${index}`, file);
        }
      }

      return formData;
    }

    return JSON.stringify(request.params);
  }
}

export default new ApiService();
